<script setup lang="ts">
import type { NuxtLinkProps } from '#app'

const props = defineProps<NuxtLinkProps>()

const root = useRootNavItem()
</script>

<template>
  <NuxtLink v-bind="props" :to="root.to" :aria-label="root.label">
    <IconsLogoJuridika aria-hidden="true" class="fill-current" />
  </NuxtLink>
</template>
